/* istanbul ignore file */
export { default } from "./jsw-interactive-board";
